export class GirisRequest {

  kullaniciAdi: string;
  sifre: string;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
  }

}
